import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

function AuthHeader({ current = "login" }) {
  return (
    <header className="auth-header">
      <div className="auth-header-inner">
        <Link to="/vendor" className="auth-header-brand">
          <img src={logo} alt="IM Online" className="auth-header-logo" />
          <div className="auth-header-text">
            <span className="auth-header-title">IM ONLINE</span>
            <span className="auth-header-badge">SELLER CENTER</span>
          </div>
        </Link>

        <div className="auth-header-actions">
          {current === "login" ? (
            <div className="auth-header-nav-item">
              <span className="auth-header-subtext">New seller?</span>
              <Link to="/vendor/register" className="btn btn-outline-primary btn-sm auth-header-btn">
                Create Account
              </Link>
            </div>
          ) : (
            <div className="auth-header-nav-item">
              <span className="auth-header-subtext">Already registered?</span>
              <Link to="/vendor/login" className="btn btn-outline-primary btn-sm auth-header-btn">
                Sign In
              </Link>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}

export default AuthHeader;
